module.exports = "https://web-assets.ifttt.com/packs/media/careers/career_cover-0764d629.jpg";